const STEPS = [
  { step: "01", title: "Enquiry", desc: "Reach out on WhatsApp with your vision, occasion and timeline." },
  { step: "02", title: "Consultation", desc: "We discuss colours, motifs, fabric and budget — one-to-one." },
  { step: "03", title: "Design Sketch", desc: "A hand-sketched blueprint of your ARVI piece, for your approval." },
  { step: "04", title: "The Painting", desc: "Weeks of meticulous brushwork by the master artist herself." },
  { step: "05", title: "Final Finish", desc: "Edging, polishing, and careful quality assurance by hand." },
  { step: "06", title: "Delivery", desc: "Your heirloom arrives in bespoke ARVI packaging, ready to be worn." },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="bg-ivory py-24 md:py-32"
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 md:gap-16">
          <div className="md:col-span-4 md:sticky md:top-28 self-start reveal">
            <p className="text-overline text-gold mb-5">The Commissioning Process</p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-maroon tracking-tight leading-[1.05]">
              Six considered
              <br />
              <span className="italic">steps to a heirloom.</span>
            </h2>
            <p className="mt-6 text-maroon/70 text-[15px] leading-relaxed max-w-md">
              A quiet, thoughtful process — no pressure, no showrooms.
              Just a direct conversation between you and the artist.
            </p>
          </div>

          <ol className="md:col-span-7 md:col-start-6 relative">
            <span
              aria-hidden="true"
              className="absolute left-[18px] top-2 bottom-2 w-px bg-[hsl(var(--gold)/0.4)]"
            />
            {STEPS.map((s) => (
              <li
                key={s.step}
                data-testid={`process-step-${s.step}`}
                className="relative pl-16 pb-12 last:pb-0 reveal"
              >
                <span className="absolute left-0 top-0 flex h-9 w-9 items-center justify-center rounded-full border border-gold bg-ivory serif-numeral text-maroon text-sm">
                  {s.step.slice(-1)}
                </span>
                <div className="flex flex-col md:flex-row md:items-baseline md:gap-6">
                  <p className="font-display italic text-gold text-sm shrink-0 md:w-10">
                    {s.step}
                  </p>
                  <div>
                    <h3 className="font-display text-2xl md:text-[26px] text-maroon leading-tight">
                      {s.title}
                    </h3>
                    <p className="mt-3 text-maroon/70 text-[15px] leading-relaxed max-w-md">
                      {s.desc}
                    </p>
                  </div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
